export const getStatusSeller = (status: string) => {
  switch (status) {
    case 'Saved':
      return '';
    case 'Delivered':
    case 'PartiallyShipped':
    case 'Shipped':
      return '배송완료';
    case 'Inprogress':
      return '배송중';
    case 'Canceled':
      return '주문취소';
    case 'Request':
      return '배송요청';
    default:
      return '';
  }
};

export const downloafFile = async (data: Blob, fileName: string) => {
  const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
}